import apiClient from './client';

/**
 * Tax Settings API
 * Endpoints for managing VAT and other tax configurations
 */

/**
 * Get current tax settings
 * @returns {Promise<Object>} Tax settings data
 */
export const getTaxSettings = async () => {
  const response = await apiClient.get('/settings/tax');
  return response.data;
};

/**
 * Update tax settings
 * @param {Object} settings - Settings to update
 * @returns {Promise<Object>} Updated settings
 */
export const updateTaxSettings = async (settings) => {
  const response = await apiClient.put('/settings/tax', settings);
  return response.data;
};

export default {
  getTaxSettings,
  updateTaxSettings
};
